import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { } from "react-icons/fa";
import Sidenav from './nav';
import { HOSTNAME } from './pages/Utils/defaults';

const drawerWidth = 240;

const App = () => {
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {
    // Check if the user is on a mobile device
    const isMobileDevice = /Mobi/.test(navigator.userAgent);

    // Redirect to the desktop view website if the user is not on a mobile device
    if (!isMobileDevice) {
      window.location.href = `https://${HOSTNAME + location.pathname}`;
    }
  }, []);




  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/home" />} />
      <Route path="/*" element={<Sidenav />} exact />

    </Routes>
  );
}



export default App;
